import mutateCreateKiosk from "./mutateCreateKiosk"
import mutateUpdateKiosk from "./mutateUpdateKiosk"
import mutateInviteKiosk from "./mutateInviteKiosk"
import mutateDeleteKiosk from "./mutateDeleteKiosk"
import withKioskFormDetails from "./withKioskFormDetails"
import withKioskFormOptions from "./withKioskFormOptions"
import withKiosks from "./withKiosks"

const queries = {
  mutateCreateKiosk,
  mutateUpdateKiosk,
  mutateInviteKiosk,
  mutateDeleteKiosk,
  withKioskFormDetails,
  withKioskFormOptions,
  withKiosks
}

export default queries



// WEBPACK FOOTER //
// ./src/Kiosks/queries/index.js